import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';

export const SuccessMessage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Flex align="center" gap={6}>
      <CheckOutlined style={{ color: kccThemeConstants.COLORS.SUCCESS }} />
      <Typography.Text style={{ margin: 0, color: kccThemeConstants.COLORS.SUCCESS }}>
        {t('serviceRequestPage.verification.codeValid')}
      </Typography.Text>
    </Flex>
  );
};
